import { render, staticRenderFns } from "./NatConLomAwardPreview.vue?vue&type=template&id=5495e396"
import script from "./NatConLomAwardPreview.vue?vue&type=script&lang=js"
export * from "./NatConLomAwardPreview.vue?vue&type=script&lang=js"
import style0 from "./NatConLomAwardPreview.vue?vue&type=style&index=0&id=5495e396&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports